import request from 'api/request';

export default function activeTicketIndexRoute() {
  return request({ url: '/tickets/active' });
}
